





















import { Component, Vue } from 'vue-property-decorator'
import { CalendarAssignmentInterface } from '@/commerce/Common/interfaces/calendar-assignment.interface'
import { calendarTemplateService } from '@/commerce/Common/services/calendar-template.service'

@Component({})
export default class CalendarTemplateProductAssignmentList extends Vue {
    public assignments: CalendarAssignmentInterface[]

    data() {
        return {
            headers: [
                {
                    text: 'Product',
                    value: 'ProductName',
                },
                {
                    text: 'CalendarTemplate',
                    value: 'CalendarTemplateName',
                }
            ],
            assignments: [],
        };
    }

    async created() {
        this.assignments = await calendarTemplateService.getAssignments()
    }
}
